interface MiniProgramBridge {
  getEnv(callback: (result: { miniprogram: boolean }) => void): void
  redirectTo(options: { url: string; success?: () => void; fail?: () => void }): void
}

declare global {
  interface Window {
    wx?: { miniProgram?: MiniProgramBridge }
    WeixinJSBridge?: unknown
  }
}

function waitForBridge(timeoutMs = 3_000): Promise<MiniProgramBridge | null> {
  const current = window.wx?.miniProgram
  if (current) return Promise.resolve(current)
  return new Promise(resolve => {
    const finish = () => resolve(window.wx?.miniProgram ?? null)
    document.addEventListener('WeixinJSBridgeReady', finish, { once: true })
    window.setTimeout(finish, timeoutMs)
  })
}

export async function returnToMiniProgram(callId: string): Promise<boolean> {
  const bridge = await waitForBridge()
  if (!bridge) return false
  const inMiniProgram = await new Promise<boolean>(resolve => {
    bridge.getEnv(result => resolve(result.miniprogram))
  })
  if (!inMiniProgram) return false
  return new Promise(resolve => {
    bridge.redirectTo({
      url: `/pages/voice-call/result?id=${encodeURIComponent(callId)}`,
      success: () => resolve(true),
      fail: () => resolve(false),
    })
  })
}
